import { useEffect, useRef } from "react";

export function useInactivityHandler(timeout = 60000, onTimeout = () => {}) {
  const timerRef = useRef(null);
  const lastActivityRef = useRef(Date.now());

  const checkInactivity = () => {
    const now = Date.now();
    const elapsed = now - lastActivityRef.current;

    if (elapsed >= timeout) {
      onTimeout();
    }
  };

  const resetTimer = () => {
    lastActivityRef.current = Date.now();
    localStorage.setItem("lastActivity", lastActivityRef.current.toString());

    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(checkInactivity, timeout);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];
    const handleActivity = () => resetTimer();

    events.forEach((e) => window.addEventListener(e, handleActivity));

    const stored = localStorage.getItem("lastActivity");
    if (stored) {
      lastActivityRef.current = parseInt(stored, 10);
    }
    resetTimer();

    const interval = setInterval(checkInactivity, 60 * 1000);

    return () => {
      events.forEach((e) => window.removeEventListener(e, handleActivity));
      if (timerRef.current) clearTimeout(timerRef.current);
      clearInterval(interval);
    };
  }, [timeout, onTimeout]);

  return { resetTimer };
}